export const AVATAR_COLORS = {
    ASCII_BASE: 65,
    ASCII_COUNTER_RAISE: 14,
    L_BACKGROUND_COLOR: 80,
    L_FONT_COLOR: 40,
}